import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChange, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, ReactiveFormsModule, FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';

import { ContactItem, ChangeContactRequest } from '../interfaces';

@Component({
  selector: 'mcrit-gestio-manage-project-contact-list',
  templateUrl: './contact-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./contact-list.component.css', '../list-cards.css']
})


export class ContactListComponent implements OnInit, OnChanges {
  @Input() contactList: Array<ContactItem> = [];
  @Input() showAsyncProgress: boolean = false;
  @Output() changeContacts: EventEmitter<ChangeContactRequest> = new EventEmitter<ChangeContactRequest>();

  public showEditor: boolean = false;
  public newContactData: ContactItem;
  public contactsFormGroups: Array<FormGroup>;

  private requestChange(action: 'ADD' | 'REMOVE' | 'UPDATE', contact: ContactItem): void {
    this.changeContacts.emit({
      action: action,
      contact: contact
    });
    this.closeEditor();
  }

  private updateReactiveForms(): void {
    if (!this.contactList) {
      return;
    }

    this.contactsFormGroups = this.contactList.map(item => new FormGroup({
      id: new FormControl(item.id),
      idProjecte: new FormControl(item.idProjecte),
      tipus: new FormControl(item.tipus),
      nom: new FormControl(item.nom),
      email: new FormControl(item.email),
      tlf: new FormControl(item.tlf),
      //skype: new FormControl(item.skype),
      linkedin: new FormControl(item.linkedin),
      mobil: new FormControl(item.mobil),
      comentari: new FormControl(item.comentari),
      adreca: new FormControl(item.adreca)
    }));

  }

  public addContact() {
    this.requestChange('ADD', Object.assign({}, this.newContactData));
  }

  public closeEditor() {
    this.showEditor = false;
  }

  public updateContact(action: 'REMOVE' | 'UPDATE', contactForm: FormGroup): void {
    this.requestChange(action, Object.assign({}, contactForm.value));
  }

  public openEditor() {
    this.newContactData = {
      tipus: '',
      nom: '',
      email: '',
      tlf: '',
//      skype: '',
      linkedin: '',
      mobil: '',
      comentari: '',
      adreca: '',
      id_client: null
    };

    this.showEditor = true;
  }

  constructor(public translate: TranslateService, public languageService: LanguageService) { }

  ngOnInit() {
    this.updateReactiveForms();
  }

  ngOnChanges(changes: {[propertyName: string]: SimpleChange}) {
    if (changes['contactList']) {
      this.updateReactiveForms();
    }
  }

}
